import { useEffect, useState } from "react";
import axiosMain from "../../http/axiosMain";

export const useListInflucenrs = () => {
  const [selectedTab, setSelectedTab] = useState("pending");
  const [currentPage, setCurrenPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(10);
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);

  const listInfluencers = async () => {
    setLoading(true);
    try {
      let url = "/api/admin/influencers/list-influencers";

      let query = "";
      if (selectedTab) {
        query += `status=${selectedTab}&`;
      }

      if (currentPage) {
        query += `page=${currentPage}&`;
      }

      if (limit) {
        query += `limit=${limit}&`;
      }

      const resp = await axiosMain.post(`${url}?${query}`);

      if (resp.data.success) {
        setInfluencers(resp.data.resp?.data || []);
        setTotal(resp.data.resp.meta?.total || 0);
      } else {
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    listInfluencers();
  }, [selectedTab, limit, currentPage]);

  return {
    listInfluencers,
    influencers,
    loading,
    setSelectedTab,
    setCurrenPage,
    selectedTab,
    currentPage,
    limit,
    total,
  };
};
